import React, { useState, useEffect, useCallback, memo } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Select, MenuItem, FormControl, InputLabel, Button
} from '@mui/material';

const LocationDialog = memo(({ open, onClose, selectedLocation, initialData, kcs, onSave }) => {
  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    if (open) {
      setFormData(initialData);
    }
  }, [open, initialData]);

  const handleChange = useCallback((field) => (e) => {
    setFormData(prev => ({ ...prev, [field]: e.target.value }));
  }, []);

  const handleSave = () => {
    onSave(formData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{selectedLocation ? 'Standort bearbeiten' : 'Neuen Standort hinzufügen'}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel>Kompetenz-Center</InputLabel>
          <Select
            value={formData.competence_center_id}
            onChange={handleChange('competence_center_id')}
          >
            {kcs.map((kc) => (
              <MenuItem key={kc.id} value={kc.id}>
                {kc.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="PLZ (optional)"
          value={formData.plz}
          onChange={handleChange('plz')}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Stadt"
          value={formData.city}
          onChange={handleChange('city')}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Ortsteil"
          value={formData.district}
          onChange={handleChange('district')}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Planergruppe"
          value={formData.planner_group}
          onChange={handleChange('planner_group')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button onClick={handleSave} variant="contained">
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default LocationDialog;
